import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';

const RedirectRoute = () => {
    const location = useLocation();
    const { Flag, isAuthenticated, Role } = useSelector((state) => state.auth);

    console.log('RedirectRoute - isAuthenticated:', isAuthenticated);
    console.log('RedirectRoute - Role:', Role);
    console.log('RedirectRoute - Flag:', Flag);
    console.log('RedirectRoute - Current path:', location.pathname);

    if(isAuthenticated && location.pathname !== "/Home/verify" && Flag === false) {
        console.log('RedirectRoute - Redirecting to verify');
        return <Navigate to="/Home/verify" replace />;
    }

    if(isAuthenticated && (Role === 'Free_User' || Role === 'Pro_User') && !location.pathname.startsWith('/User')) {
        console.log('RedirectRoute - Redirecting User to /User');
        return <Navigate to="/User" replace />;
    }

    if(isAuthenticated && Role === 'Admin' && !location.pathname.startsWith('/Admin')) {
        console.log('RedirectRoute - Redirecting Admin to /Admin');
        return <Navigate to="/Admin" replace />;
    }

    if(isAuthenticated && Role === 'Moderator' && !location.pathname.startsWith('/Moderator')) {
        console.log('RedirectRoute - Redirecting Moderator to /Moderator');
        return <Navigate to="/Moderator" replace />;
    }


    if(!isAuthenticated) {
        console.log('RedirectRoute - User not authenticated, redirecting to /Home');
        return <Navigate to="/Home" replace />;
    }

    // If authenticated and in correct location, return null to show the landing page
    console.log('RedirectRoute - Authenticated user in correct location, showing landing page');
    return <Navigate to="/Home/main" replace />;
};

export default RedirectRoute;